import LeeAlert from './src/LeeAlert.vue'
import LeeBadge from './src/LeeBadge.vue'
import LeeButton from './src/LeeButton.vue'
import LeeCells from './src/LeeCells.vue'
import LeeCell from './src/LeeCell.vue'
import LeeCollapse from './src/LeeCollapse.vue'
import LeeCollapseItem from './src/LeeCollapseItem.vue'
import LeeColorDisk from './src/LeeColorDisk.vue'
import LeeCountDown from './src/LeeCountDown.vue'
import LeeDialog from './src/LeeDialog.vue'
import LeeDragSort from './src/LeeDragSort.vue'
import LeeGesturePassword from './src/LeeGesturePassword.vue'
import LeeImgContrast from './src/LeeImgContrast.vue'
import LeeImgEffect from './src/LeeImgEffect.vue'
import LeeInputNumber from './src/LeeInputNumber.vue'
import LeeLoadImg from './src/LeeLoadImg.vue'
import LeeLuckBing from './src/LeeLuckBing.vue'
import LeeLuckDraw from './src/LeeLuckDraw.vue'
import LeeLuckGrid from './src/LeeLuckGrid.vue'
import LeeMenuTree from './src/LeeMenuTree.vue'
import LeeMenuItem from './src/LeeMenuItem.vue'
import LeeNotification from './src/LeeNotification.vue'
import LeeNotificationItem from './src/LeeNotificationItem.vue'
import LeeOption from './src/LeeOption.vue'
import LeePagination from './src/LeePagination.vue'
import LeePasswordInput from './src/LeePasswordInput.vue'
import LeePay from './src/LeePay.vue'
import LeeProgress from './src/LeeProgress.vue'
import LeeRadio from './src/LeeRadio.vue'
import LeeRadioGroup from './src/LeeRadioGroup.vue'
import LeeScratch from './src/LeeScratch.vue'
import LeeScroll from './src/LeeScroll.vue'
import LeeScrollLyrics from './src/LeeScrollLyrics.vue'
import LeeScrollSelect from './src/LeeScrollSelect.vue'
import LeeSelect from './src/LeeSelect.vue'
import LeeSlide from './src/LeeSlide.vue'
import LeeSlideCheck from './src/LeeSlideCheck.vue'
import LeeSlideImage from './src/LeeSlideImage.vue'
import LeeStarEvaluate from './src/LeeStarEvaluate.vue'
import LeeSteps from './src/LeeSteps.vue'
import LeeStep from './src/LeeStep.vue'
import LeeSwiperDelete from './src/LeeSwiperDelete.vue'
import LeeSwitch from './src/LeeSwitch.vue'
import LeeTag from './src/LeeTag.vue'
import LeeTagGroup from './src/LeeTagGroup.vue'
import LeeTagCloud from './src/LeeTagCloud.vue'
import LeeTimeline from './src/LeeTimeline.vue'
import LeeTimelineItem from './src/LeeTimelineItem.vue'
import LeeToast from './src/LeeToast.vue'
import LeeToolTip from './src/LeeToolTip.vue'
import LeeTransfer from './src/LeeTransfer.vue'
const LeeVue = {}
LeeVue.install = function (Vue) {
    Vue.component(LeeAlert.name, LeeAlert)
    Vue.component(LeeBadge.name, LeeBadge)
    Vue.component(LeeButton.name, LeeButton)
    Vue.component(LeeCells.name, LeeCells)
    Vue.component(LeeCell.name, LeeCell)
    Vue.component(LeeCollapse.name, LeeCollapse)
    Vue.component(LeeCollapseItem.name, LeeCollapseItem)
    Vue.component(LeeColorDisk.name, LeeColorDisk)
    Vue.component(LeeCountDown.name, LeeCountDown)
    Vue.component(LeeDialog.name, LeeDialog)
    Vue.component(LeeDragSort.name, LeeDragSort)
    Vue.component(LeeGesturePassword.name, LeeGesturePassword)
    Vue.component(LeeImgContrast.name, LeeImgContrast)
    Vue.component(LeeImgEffect.name, LeeImgEffect)
    Vue.component(LeeInputNumber.name, LeeInputNumber)
    Vue.component(LeeLoadImg.name, LeeLoadImg)
    Vue.component(LeeLuckBing.name, LeeLuckBing)
    Vue.component(LeeLuckDraw.name, LeeLuckDraw)
    Vue.component(LeeLuckGrid.name, LeeLuckGrid)
    Vue.component(LeeMenuTree.name, LeeMenuTree)
    Vue.component(LeeMenuItem.name, LeeMenuItem)
    Vue.component(LeeNotification.name, LeeNotification)
    Vue.component(LeeNotificationItem.name, LeeNotificationItem)
    Vue.component(LeeOption.name, LeeOption)
    Vue.component(LeePagination.name, LeePagination)
    Vue.component(LeePasswordInput.name, LeePasswordInput)
    Vue.component(LeePay.name, LeePay)
    Vue.component(LeeProgress.name, LeeProgress)
    Vue.component(LeeRadio.name, LeeRadio)
    Vue.component(LeeRadioGroup.name, LeeRadioGroup)
    Vue.component(LeeScratch.name, LeeScratch)
    Vue.component(LeeScroll.name, LeeScroll)
    Vue.component(LeeScrollLyrics.name, LeeScrollLyrics)
    Vue.component(LeeScrollSelect.name, LeeScrollSelect)
    Vue.component(LeeSelect.name, LeeSelect)
    Vue.component(LeeSlide.name, LeeSlide)
    Vue.component(LeeSlideCheck.name, LeeSlideCheck)
    Vue.component(LeeSlideImage.name, LeeSlideImage)
    Vue.component(LeeStarEvaluate.name, LeeStarEvaluate)
    Vue.component(LeeStep.name, LeeStep)
    Vue.component(LeeSteps.name, LeeSteps)
    Vue.component(LeeSwiperDelete.name, LeeSwiperDelete)
    Vue.component(LeeSwitch.name, LeeSwitch)
    Vue.component(LeeTag.name, LeeTag)
    Vue.component(LeeTagGroup.name, LeeTagGroup)
    Vue.component(LeeTagCloud.name, LeeTagCloud)
    Vue.component(LeeTimeline.name, LeeTimeline)
    Vue.component(LeeTimelineItem.name, LeeTimelineItem)
    Vue.component(LeeToast.name, LeeToast)
    Vue.component(LeeToolTip.name, LeeToolTip)
    Vue.component(LeeTransfer.name, LeeTransfer)
}
export default LeeVue
